import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from 'react-redux';
import { styles } from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";

// Attestations de mutation par décès (attestation immobilière) - successions confondues
// Id simulateur 54, A2-13bis

function Simulateur_54(props, simulateur, isParent, departements) {
    const dispatch = useDispatch();

    const currentIdSimu = 54
    let currUser = JSON.parse(localStorage.getItem("efluser"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")) {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [valeur_biens_communs, setCommuns] = useState(0)
    const [valeur_biens_propres_1, setPropres1] = useState(0)
    const [valeur_biens_propres_2, setPropres2] = useState(0)
    const [nombre_publicite_fonciere, setSPF] = useState(0)

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": 0,
                "bureauid": parseInt(currUser.id),
                "inputs": {}
            };

            if (setter === setDepartement) {
                Object.assign(object['inputs'], { 'valeur_biens_communs': parseInt(valeur_biens_communs) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_1': parseInt(valeur_biens_propres_1) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_2': parseInt(valeur_biens_propres_2) })
                Object.assign(object['inputs'], { 'nombre_publicite_fonciere': parseInt(nombre_publicite_fonciere) })
                object.departementid = parseInt(value)
            }

            if (setter === setCommuns) {
                Object.assign(object['inputs'], { 'valeur_biens_communs': parseInt(value) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_1': parseInt(valeur_biens_propres_1) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_2': parseInt(valeur_biens_propres_2) })
                Object.assign(object['inputs'], { 'nombre_publicite_fonciere': parseInt(nombre_publicite_fonciere) })
                object.departementid = parseInt(departement)
            }

            if (setter === setPropres1) {
                Object.assign(object['inputs'], { 'valeur_biens_communs': parseInt(valeur_biens_communs) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_1': parseInt(value) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_2': parseInt(valeur_biens_propres_2) })
                Object.assign(object['inputs'], { 'nombre_publicite_fonciere': parseInt(nombre_publicite_fonciere) })
                object.departementid = parseInt(departement)
            }

            if (setter === setPropres2) {
                Object.assign(object['inputs'], { 'valeur_biens_communs': parseInt(valeur_biens_communs) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_1': parseInt(valeur_biens_propres_1) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_2': parseInt(value) })
                Object.assign(object['inputs'], { 'nombre_publicite_fonciere': parseInt(nombre_publicite_fonciere) })
                object.departementid = parseInt(departement)
            }

            if (setter === setSPF) {
                Object.assign(object['inputs'], { 'valeur_biens_communs': parseInt(valeur_biens_communs) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_1': parseInt(valeur_biens_propres_1) })
                Object.assign(object['inputs'], { 'valeur_biens_propres_2': parseInt(valeur_biens_propres_2) })
                Object.assign(object['inputs'], { 'nombre_publicite_fonciere': parseInt(value) })
                object.departementid = parseInt(departement)
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

                <TextfieldRemarques handleChange={handleChangeRemarque} />

                {props?.isParent === true && props.departements !== "" ?
                    <div style={styles.cardRow}>
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                            handleChange={handleChange} setter={setDepartement} />
                    </div>
                    :
                    <></>
                }

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Valeur totale des biens communs transmis :
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setCommuns}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Valeur totale des biens propres 1er époux transmis :
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setPropres1}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Valeur totale des biens propres 2nd époux transmis :
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setPropres2}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Nombre de service de publicité foncière ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre"}
                        setter={setSPF}
                    />
                </div>

            </div>

        </div>
    )
}

export default Simulateur_54;
